export default __webpack_public_path__ + "static/media/warning.icon.1856b5ee.svg";